<template>
    <div>
        <limitless-page-header :loading="busy_loading" :title="'Kunder'" :sub-title="customer_name" :title-id="customer_id">
            <template #header-elements>
                <limitless-page-header-button url="/customers" icon="icon-circle-left2">Till Listan</limitless-page-header-button>
            </template>
        </limitless-page-header>

        <div class="content" v-if="!initialized && busy_loading">
            <i class="icon-spinner2 spinner"></i>
        </div>
        <div class="content" v-else-if="customer">
            <div v-if="customer.unpaid_amount > 0" class="alert alert-danger alert-styled-left alert-bordered">
                <router-link :to="{ name: 'customers.edit', params: { id: customer.CustomerID } }" style="font-size: 24px; color: #333333;">
                    OBS! Kunden har förfallna fakturor: {{ formatCurrency((Math.round(parseFloat(customer.unpaid_amount) * 100) / 100), 2, (customer.currency ? customer.currency.CurrencyShort : 'SEK')) }}
                </router-link>
            </div>
            <ValidationObserver ref="customerform">
                <div class="row">
                    <div class="col-lg-8">
                        <div class="card">
                            <div class="card-header header-elements-inline bg-light">
                                <h6 class="card-title"><i class="icon-office mr-2"></i>Kundinformation</h6>
                                <div class="header-elements">
                                    <select-with-validation
                                        vid="CustomerStatusID"
                                        component="customer-status-filter"
                                        :reduce="(opt) => opt.id"
                                        v-model="customer.CustomerStatusID"
                                        label="Status"
                                        hide-label
                                        style="width: 230px;"
                                    ></select-with-validation>
                                </div>
                            </div>
                            <div class="card-body">
                                <div class="row">
                                    <label class="col-form-label col-lg-2">Kundgrupp</label>
                                    <div class="col-auto flex-grow-1">
                                        <div class="form-group mb-1 d-flex">
                                            <div style="width: 120px; padding-top: 8px; padding-bottom: 8px;" class="custom-control custom-switch custom-switch-square custom-control-danger">
                                                <input type="checkbox" class="custom-control-input" id="chk-supekort" v-model="customer.SellsBrandSHT" :true-value="1" :false-value="0">
                                                <label class="custom-control-label" for="chk-supekort">Supékort</label>
                                            </div>
                                            <div class="flex-grow-1" v-if="customer.SellsBrandSHT">
                                                <select-with-validation
                                                    component="customer-group-filter"
                                                    :filter="(options) => options.filter((opt) => opt.Brand === 'SHT')"
                                                    vid="CustomerGroupID_SHT"
                                                    label="Kundgrupp Supékort"
                                                    :reduce="(opt) => opt.id"
                                                    v-model="customer.CustomerGroupID_SHT"
                                                    hide-label
                                                    rules="required"
                                                    :clearable="false"
                                                ></select-with-validation>
                                            </div>
                                        </div>
                                        <div class="form-group d-flex">
                                            <div style="width: 120px; padding-top: 8px; padding-bottom: 8px;" class="custom-control custom-switch custom-switch-square custom-control-primary">
                                                <input type="checkbox" class="custom-control-input" id="chk-newport" v-model="customer.SellsBrandNPC" :true-value="1" :false-value="0">
                                                <label class="custom-control-label" for="chk-newport">Newport</label>
                                            </div>
                                            <div class="flex-grow-1" v-if="customer.SellsBrandNPC">
                                                <select-with-validation
                                                    component="customer-group-filter"
                                                    :filter="(options) => options.filter((opt) => opt.Brand === 'NPC')"
                                                    vid="CustomerGroupID_SHT"
                                                    label="Kundgrupp Newport"
                                                    :reduce="(opt) => opt.id"
                                                    v-model="customer.CustomerGroupID_NPC"
                                                    hide-label
                                                    rules="required"
                                                    :clearable="false"
                                                ></select-with-validation>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div class="row">
                                    <label class="col-form-label col-lg-2 pt-0">Kundtyp</label>
                                    <div class="col-auto flex-grow-1">
                                        <ValidationObserver
                                            vid="IsCompany"
                                            label="Kundtyp"
                                            class="form-group"
                                            tag="div"
                                            rules="required"
                                        >
                                            <div class="custom-control custom-radio custom-control-inline">
                                                <input type="radio" class="custom-control-input" name="IsCompany" id="chk-is-company" :value="1" v-model="customer.IsCompany">
                                                <label class="custom-control-label" for="chk-is-company">Företag</label>
                                            </div>
                                            <div class="custom-control custom-radio custom-control-inline">
                                                <input type="radio" class="custom-control-input" name="IsCompany" id="chk-is-private" :value="0" v-model="customer.IsCompany">
                                                <label class="custom-control-label" for="chk-is-private">Privatperson</label>
                                            </div>
                                        </ValidationObserver>
                                    </div>
                                </div>
                                <div class="row">
                                    <label class="col-form-label col-lg-2">Säljare</label>
                                    <div class="col-auto flex-grow-1">
                                        <select-with-validation
                                            component="seller-filter"
                                            label="Säljare"
                                            vid="SellerID"
                                            v-model="customer.SellerID"
                                            :reduce="(opt) => opt.id"
                                            hide-label
                                        ></select-with-validation>
                                    </div>
                                </div>
                                <div class="row">
                                    <label class="col-form-label col-lg-2">Kund<span class="text-danger">*</span></label>
                                    <div class="col-auto flex-grow-1">
                                        <input-with-validation
                                            label="Kund"
                                            vid="CompanyName"
                                            v-model="customer.CompanyName"
                                            rules="required"
                                            hide-label
                                        ></input-with-validation>
                                    </div>
                                    <div class="col-auto">
                                        <a
                                            :href="'https://www.allabolag.se/what/' + customer.CompanyName"
                                            class="btn btn-outline-secondary"
                                            target="_blank"
                                            rel="noopener noreferrer"
                                        >
                                            Allabolag<i class="ml-2 icon-search4"></i>
                                        </a>
                                    </div>
                                </div>
                                <div class="row">
                                    <label class="col-form-label col-lg-2">
                                        {{ (customer.IsCompany ? 'Org. nr' : 'Pers. nr') }}
                                        <span class="text-danger" v-if="(customer.CustomerID > 0 && customer.invoices_count > 0 && (customer.VatNo === null || customer.VatNo.length === 0))">*</span>
                                    </label>
                                    <div class="col-auto flex-grow-1">
                                        <input-with-validation
                                            :label="(customer.IsCompany ? 'Org. nr' : 'Pers. nr')"
                                            vid="OrgNo"
                                            v-model="customer.OrgNo"
                                            hide-label
                                            :rules="{ required: (customer.CustomerID > 0 && customer.invoices_count > 0 && (customer.VatNo === null || customer.VatNo.length === 0)) }"
                                        ></input-with-validation>
                                    </div>
                                    <div class="col-auto">
                                        <a
                                            :href="'https://www.allabolag.se/what/' + customer.OrgNo"
                                            class="btn btn-outline-secondary"
                                            target="_blank"
                                            rel="noopener noreferrer"
                                        >
                                            Allabolag<i class="ml-2 icon-search4"></i>
                                        </a>
                                    </div>
                                </div>
                                <div class="row">
                                    <label class="col-form-label col-lg-2">VAT nr.</label>
                                    <div class="col-auto flex-grow-1">
                                        <input-with-validation
                                            label="VAT nr"
                                            vid="VatNo"
                                            v-model="customer.VatNo"
                                            hide-label
                                        ></input-with-validation>
                                    </div>
                                </div>
                                <div class="row">
                                    <label class="col-form-label col-lg-2">Telefon/Växel</label>
                                    <div class="col-auto flex-grow-1">
                                        <input-with-validation
                                            label="Telefon/Växel"
                                            vid="PhonePBX"
                                            v-model="customer.PhonePBX"
                                            hide-label
                                        ></input-with-validation>
                                    </div>
                                </div>
                                <div class="row">
                                    <label class="col-form-label col-lg-2">Webbsida</label>
                                    <div class="col-auto flex-grow-1">
                                        <input-with-validation
                                            label="Webbsida"
                                            vid="WebUrl"
                                            v-model="customer.WebUrl"
                                            hide-label
                                        ></input-with-validation>
                                    </div>
                                </div>
                                <div class="alert alert-secondary mb-3">
                                    <div class="row">
                                        <div class="col-lg-2"></div>
                                        <div class="col-lg-10">
                                            <div class="row">
                                                <div class="col-lg-4">
                                                    <div class="custom-control custom-checkbox custom-control-inline">
                                                        <input type="checkbox" class="custom-control-input" id="chk-hasRamavtal" v-model="customer.hasRamavtal" :true-value="1" :false-value="0">
                                                        <label class="custom-control-label" for="chk-hasRamavtal">Ramavtalskund</label>
                                                    </div>
                                                </div>
                                                <div class="col-lg-4">
                                                    <div class="custom-control custom-checkbox custom-control-inline">
                                                        <input type="checkbox" class="custom-control-input" id="chk-Invoice_SveFaktura" v-model="customer.Invoice_SveFaktura" :true-value="1" :false-value="0">
                                                        <label class="custom-control-label" for="chk-Invoice_SveFaktura">Svefaktura</label>
                                                    </div>
                                                </div>
                                                <div class="col-lg-4">
                                                    <div class="custom-control custom-checkbox custom-control-inline">
                                                        <input type="checkbox" class="custom-control-input" id="chk-noPostalSpam" v-model="customer.noPostalSpam" :true-value="1" :false-value="0">
                                                        <label class="custom-control-label" for="chk-noPostalSpam">Ingen reklam!</label>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div class="row">
                                    <label class="col-form-label col-lg-2">Betalningsvillkor<span class="text-danger">*</span></label>
                                    <div class="col-auto flex-grow-1">
                                        <select-with-validation
                                            label="Betalningsvillkor"
                                            vid="PayDays"
                                            v-model="customer.PayDays"
                                            hide-label
                                            component="pay-days-filter"
                                            :reduce="(opt) => opt.id"
                                        >
                                        </select-with-validation>
                                    </div>
                                </div>
                                <div class="row">
                                    <label class="col-form-label col-lg-2">Momstyp<span class="text-danger">*</span></label>
                                    <div class="col-auto flex-grow-1">
                                        <select-with-validation
                                            component="vat-type-filter"
                                            label="Momstyp"
                                            vid="VatTypeID"
                                            v-model="customer.VatTypeID"
                                            :reduce="(opt) => opt.id"
                                            hide-label
                                        ></select-with-validation>
                                    </div>
                                </div>
                                <div class="row">
                                    <label class="col-form-label col-lg-2">Valuta<span class="text-danger">*</span></label>
                                    <div class="col-auto flex-grow-1">
                                        <select-with-validation
                                            component="currency-filter"
                                            label="Valuta"
                                            vid="CurrencyID"
                                            v-model="customer.CurrencyID"
                                            :reduce="(opt) => opt.id"
                                            hide-label
                                            :disabled="invoice_data && invoice_data.data.length > 0"
                                        ></select-with-validation>
                                    </div>
                                </div>
                                <div class="row">
                                    <label class="col-form-label col-lg-2">Språk<span class="text-danger">*</span></label>
                                    <div class="col-auto flex-grow-1">
                                        <select-with-validation
                                            label="Språk"
                                            vid="InvoiceLang"
                                            v-model="customer.InvoiceLang"
                                            :reduce="(opt) => opt.id"
                                            hide-label
                                            :options="languages"
                                        ></select-with-validation>
                                    </div>
                                </div>
                                <div class="row">
                                    <label class="col-form-label col-lg-2">E-faktura</label>
                                    <div v-if="customer.Invoice_SveFaktura" class="col-form-label col-auto flex-grow-1">
                                        send.supekort@esyncloud.ai (Svefaktura)
                                    </div>
                                    <div v-if="!customer.Invoice_SveFaktura" class="col-form-label col-2">
                                        <div class="custom-control custom-checkbox custom-control-inline">
                                            <input type="checkbox" class="custom-control-input" name="Invoice_E_Setting" id="chk-Invoice_E_Setting" :true-value="1" :false-value="0" v-model="customer.Invoice_E_Setting">
                                            <label class="custom-control-label" for="chk-Invoice_E_Setting">E-faktura aktiv</label>
                                        </div>
                                    </div>
                                    <div v-if="!customer.Invoice_SveFaktura" class="col-auto flex-grow-1">
                                        <input-with-validation
                                            label="E-postadress"
                                            vid="Invoice_E_Email"
                                            v-model="customer.Invoice_E_Email"
                                            hide-label
                                        >
                                        </input-with-validation>
                                    </div>
                                </div>
                            </div>
                            <div class="card-footer">
                                <div class="d-flex justify-content-end">
                                    <limitless-button ref="btnsavecustomer" @click="saveCustomer" :busy="busy_saving" icon="icon-floppy-disk">SPARA</limitless-button>
                                </div>
                            </div>
                        </div>

                        <div v-if="customer.CustomerID > 0" class="card">
                            <div class="card-header header-elements-inline bg-light">
                                <h6 class="card-title"><i class="icon-address-book2 mr-2"></i>Kontaktpersoner</h6>
                                <div class="header-elements">
                                    <button type="button" class="btn btn-light" @click="editContact()"><i class="icon-plus3 mr-1"></i>Ny kontakt</button>
                                </div>
                            </div>
                            <div>
                                <table class="table">
                                    <tbody v-if="contacts.length > 0">
                                        <tr
                                            v-for="(contact, c_index) in contacts"
                                            :key="'c-' + c_index"
                                        >
                                            <td :class="{ 'font-weight-semibold': contact.isMain }" v-html="joinContactFields(contact)"></td>
                                            <td>
                                                <div class="d-flex justify-content-end align-items-center">
                                                    <i v-if="contact.isMain" class="ml-1 icon-star-full2 text-yellow"></i>
                                                    <button type="button" class="btn btn-light btn-icon ml-2 btn-sm" @click="editContact(contact)"><i class="icon-pencil"></i></button>
                                                </div>
                                            </td>
                                        </tr>
                                    </tbody>
                                    <tbody v-else>
                                        <tr>
                                            <td colspan="2"><i>Inga kontaktpersoner</i></td>
                                        </tr>
                                    </tbody>
                                </table>
                            </div>
                        </div>

                        <div v-if="customer.CustomerID > 0" class="card">
                            <div class="card-header header-elements-inline bg-light">
                                <h6 class="card-title"><i class="icon-mailbox mr-2"></i>Adresser</h6>
                                <div class="header-elements">
                                    <button type="button" class="btn btn-light" @click="editAddress()"><i class="icon-plus3 mr-1"></i>Ny adress</button>
                                </div>
                            </div>
                            <div>
                                <table class="table">
                                    <tbody v-if="addresses.length > 0">
                                        <tr
                                            v-for="(address, a_index) in addresses"
                                            :key="'a-' + a_index"
                                        >
                                            <td :class="{ 'font-weight-semibold': address.isMain }">{{ joinAddressFields(address) }}</td>
                                            <td>
                                                <div class="d-flex justify-content-end align-items-center">
                                                    <i v-if="address.isMain" class="ml-1 icon-star-full2 text-yellow"></i>
                                                    <i class="ml-1 icon-truck" :class="{ 'text-success-600': address.isTypeDelivery, 'text-secondary-200': !address.isTypeDelivery }"></i>
                                                    <i class="ml-1 icon-envelop3" :class="{ 'text-success-600': address.isTypePostal, 'text-secondary-200': !address.isTypePostal }"></i>
                                                    <i class="ml-1 icon-coins" :class="{
                                                        'text-danger': (address.isDefaultInvoiceAdr && address.isTypeInvoicing),
                                                        'text-success-600': (!address.isDefaultInvoiceAdr && address.isTypeInvoicing),
                                                        'text-secondary-200': !address.isTypeInvoicing
                                                    }"></i>
                                                    <button type="button" class="btn btn-light btn-icon ml-2 btn-sm" @click="editAddress(address)"><i class="icon-pencil"></i></button>
                                                </div>
                                            </td>
                                        </tr>
                                    </tbody>
                                    <tbody v-else>
                                        <tr>
                                            <td colspan="2"><i>Inga adresser</i></td>
                                        </tr>
                                    </tbody>
                                </table>
                            </div>
                        </div>
                    </div>
                    <div class="col-lg-4">
                        <div class="card">
                            <div class="card-header bg-light">
                                <h6 class="card-title"><i class="icon-clipboard3 mr-2"></i>Interna Noteringar</h6>
                            </div>
                            <div class="card-body">
                                <textarea-with-validation
                                    label="Interna Noteringar"
                                    vid="InternalNote"
                                    v-model="customer.InternalNote"
                                    hide-label
                                    :rows="10"
                                ></textarea-with-validation>
                            </div>
                        </div>

                        <div v-if="customer && customer.CustomerID > 0" class="card">
                            <div class="card-header bg-light">
                                <h6 class="card-title"><i class="icon-price-tag mr-2"></i> <span class="text-semibold">Specialpriser (per kortserie)</span></h6>
                            </div>
                            <div>
                                <table v-if="price_lists.length > 0" class="table table-xs table-striped border-bottom">
                                    <thead>
                                        <tr>
                                            <th>Kortserie</th>
                                            <th>Giltig</th>
                                            <th>Pris</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        <tr v-for="(pl, pl_idx) in price_lists" :key="'pl-' + pl_idx">
                                            <td>{{ pl.CardSeriesID }} {{ pl.SeriesName }}</td>
                                            <td>{{ pl.ValidFrom }} - {{ pl.ValidTo }}</td>
                                            <td>{{ pl.myPrice }}</td>
                                        </tr>
                                    </tbody>
                                </table>
                                <div v-else class="card-body pb-0">
                                    <i>Inga specialpriser</i>
                                </div>
                            </div>
                            <div class="card-body">
                                <button type="button" class="btn btn-secondary btn-sm mr-2" @click="showPriceListModal">
                                    LÄGG TILL/ÄNDRA
                                </button>
                            </div>
                        </div>

                        <div v-if="customer && customer.CustomerID > 0" class="card">
                            <div class="card-header bg-light header-elements-inline">
                                <h6 class="card-title"><i class="icon-price-tag mr-2"></i> <span class="text-semibold">Rabatter (per korttyp)</span></h6>
                                <div class="header-elements">
                                    <div class="custom-control custom-checkbox custom-control-inline">
                                        <input type="checkbox" class="custom-control-input" name="show_all_discounts" id="chk-show_all_discounts" v-model="show_all_discounts">
                                        <label class="custom-control-label" for="chk-show_all_discounts">Visa alla korttyper</label>
                                    </div>
                                </div>
                            </div>
                            <div>
                                <table v-if="filtered_card_series_types_discounts.length > 0" class="table table-xs table-striped border-bottom">
                                    <thead>
                                        <tr>
                                            <th>Korttyp</th>
                                            <th>Rabatt</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        <tr v-for="(cst, cst_idx) in filtered_card_series_types_discounts" :key="'cst-' + cst_idx">
                                            <td>{{ cst.label }}</td>
                                            <td>
                                                <input-with-validation
                                                    :label="cst.label"
                                                    :vid="'baseDiscount.' + cst.label"
                                                    hide-label
                                                    type="number"
                                                    step="1"
                                                    min="0"
                                                    max="100"
                                                    v-model="customer.baseDiscount[cst.label]"
                                                    class="mb-0"
                                                >
                                                    <template #input-group-append><span class="input-group-text">%</span></template>
                                                </input-with-validation>
                                            </td>
                                        </tr>
                                    </tbody>
                                </table>
                                <div v-else class="card-body">
                                    <i>Inga rabatter</i>
                                </div>
                            </div>
                        </div>

                        <div v-if="customer && customer.CustomerID > 0" class="card">
                            <div class="card-header bg-light header-elements-inline">
                                <h6 class="card-title"><i class="icon-office mr-2"></i> <span class="text-semibold">Kopplade CRM Företag</span></h6>
                            </div>
                            <div>
                                <table v-if="customer.crm_companies && customer.crm_companies.length > 0" class="table table-xs table-striped border-bottom">
                                    <thead>
                                        <tr>
                                            <th>Företag</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        <tr v-for="crm_company in customer.crm_companies" :key="'crm-company-' + crm_company.id">
                                            <td>
                                                <router-link :to="{ name: 'crm.company', params: { id: crm_company.id } }">{{ crm_company.name }}</router-link>
                                            </td>
                                        </tr>
                                    </tbody>
                                </table>
                                <div v-else class="card-body">
                                    <i>Inga kopplade företag</i>
                                </div>
                            </div>
                        </div>

                        <file-list-uploader
                            v-if="customer && customer.CustomerID > 0"
                            class="mb-3"
                            model-type="customers"
                            :model-id="id"
                            :extensions="['jpg','jpeg','png','pdf','mp4','doc','docx','xls','xlsx']"
                            :accept="'image/png,image/jpeg,application/pdf,video/mp4,' +
                            'application/msword,application/vnd.openxmlformats-officedocument.wordprocessingml.document,' +
                            'application/vnd.ms-excel,application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'"
                            multiple
                            auto-start-upload
                            display-list
                            header="Filer/dokument"
                        ></file-list-uploader>

                        <div class="card" v-if="filtered_map_addresses.length > 0">
                            <div class="card-header bg-light">
                                <h6 class="card-title"><i class="icon-location3 mr-2"></i>Karta</h6>
                            </div>
                            <div class="card-body">
                                <OpenStreetMapLeaflet
                                    :markers="filtered_map_addresses.map((add) => ({ lat: parseFloat(add.deliv_time.geo_latitude), lon: parseFloat(add.deliv_time.geo_longitude), label: add.deliv_time.Zip }))"
                                />
                                <div class="text-muted mt-2">*Visa ungefärlig position baserat på postnummer</div>
                            </div>
                        </div>
                    </div>
                </div>
            </ValidationObserver>

            <div v-if="customer.SellsBrandSHT && customer.CustomerGroupID_SHT || customer.SellsBrandNPC && customer.CustomerGroupID_NPC">
                <div v-if="customer.CustomerID > 0" class="card">
                    <div class="card-header header-elements-inline bg-light">
                        <h6 class="card-title"><i class="icon-cart5 mr-2"></i>Ordrar</h6>
                        <div class="header-elements">
                            <router-link :to="{ name: 'cardorders.edit', params: { id: 0 }, query: { customer_id: customer.CustomerID } }" class="btn btn-light"><i class="icon-plus3 mr-1"></i>Ny order</router-link>
                        </div>
                    </div>
                    <order-list :customer-id="parseInt(id)" no-wrapper></order-list>
                </div>

                <div v-if="customer.CustomerID > 0" class="card">
                    <div class="card-header header-elements-inline bg-light">
                        <h6 class="card-title"><i class="icon-coins mr-2"></i>Fakturor</h6>
                        <div class="header-elements"></div>
                    </div>
                    <rednax-datatable
                        :url="'/vue/invoices'"
                        :columns="invoice_columns"
                        :filter="invoice_filter"
                        @rowclick="invoiceRowClick"
                        :per-page="10"
                        sort-by="InvoiceID"
                        sort-order="desc"
                        size="sm"
                        ref="tblcinvoices"
                        no-wrapper
                        @data:loaded="getInvoiceStats"
                    >
                        <template #cell_InvoiceID="{ row }">
                            <router-link :to="{ name: 'invoice.edit', params: { id: row.InvoiceID } }">
                                {{ row.ocr }}
                            </router-link>
                        </template>
                        <template #cell_OrderID="{ row }">
                            <router-link :to="{ name: 'cardorders.edit', params: { id: row.OrderID } }">{{ row.OrderID }}</router-link>
                        </template>
                        <template #cell_InvoiceDate="{ row }">
                            <div>{{ row.InvoiceDate }}</div>
                            <div v-if="row.isReminded >= 1 && row.RemindDate" class="text-danger-700">P1: {{ row.RemindDate }}</div>
                            <div v-if="row.isReminded >= 2 && row.RemindDate2" class="text-danger-600">P2: {{ row.RemindDate2 }}</div>
                            <div v-if="row.RemindDate3" class="text-danger">SAMTAL: {{ row.RemindDate3 }}</div>
                            <div v-if="row.SentToKronofogden" class="text-danger">KRONOF: {{ row.KronofogdenDate }}</div>
                        </template>
                        <template #cell_InvoiceSum="{ row }">
                            {{ formatNumber(row.InvoiceSum, 2) }} {{ (row.CurrencyShort ? row.CurrencyShort : 'SEK') }}
                        </template>
                        <template #cell_InvoiceSumFull="{ row }">
                            {{ formatNumber(row.InvoiceSumFull, 2) }} {{ (row.CurrencyShort ? row.CurrencyShort : 'SEK') }}
                        </template>
                        <template #cell_debt="{ row }">
                            {{ formatNumber((row.isPaid ? 0 : row.debt), 2) }} {{ (row.CurrencyShort ? row.CurrencyShort : 'SEK') }}
                        </template>
                        <template #cell_debt_sek="{ row }">
                            {{ formatNumber((row.isPaid ? 0 : row.debt_sek), 2) }}
                        </template>
                        <template #cell_LateDays="{ row }">
                            <div v-if="row.isPaid" class="badge badge-success">Betald</div>
                            <div v-else-if="row.CustomerID === 1635" class="badge bg-blue-600 text-white">{{ row.LateDays }}</div>
                            <div v-else-if="row.debt < 0" class="badge badge-warning">{{ row.LateDays }}</div>
                            <div v-else-if="round(row.debt) !== round(row.InvoiceSumFull)" class="badge bg-purple-600 text-white">{{ row.LateDays }}</div>
                            <div v-else-if="row.LateDays < 0" class="badge bg-danger-600 text-white">{{ row.LateDays }}</div>
                            <div v-else class="badge badge-info">{{ row.LateDays }}</div>
                        </template>
                        <template #cell_Status="{ row }">
                            <div v-if="row.isPaid" class="">Betald</div>
                            <div v-else-if="row.isInsecure >= 2" class="">Kundförlust/konkurs</div>
                            <div v-else-if="row.isInsecure >= 1" class="">Osäker fodring</div>
                            <div v-else-if="row.SentToKronofogden" class="">Kronofogden</div>
                            <div v-else-if="row.LateDays < 0" class="">Förfallen</div>
                            <div v-else-if="row.isAccepted" class="">Skickad</div>
                            <div v-else class="">Ny</div>
                        </template>
                    </rednax-datatable>
                    <div class="card-body border-top">
                        <div v-if="busy_loading_invoice_stats">
                            <i class="icon-spinner2 spinner"></i>
                        </div>
                        <table v-else-if="invoice_stats" class="table table-bordered table-sm" style="max-width: 400px;">
                            <tbody>
                                <tr>
                                    <th>Väntande</th>
                                    <td class="bg-info text-right text-white">{{ formatNumber(invoice_stats.wait, 0) }} kr</td>
                                </tr>
                                <tr>
                                    <th>Förfallna</th>
                                    <td class="bg-danger text-right text-white">{{ formatNumber(invoice_stats.late, 0) }} kr</td>
                                </tr>
                                <tr>
                                    <th>Delbetalda, rest</th>
                                    <td class="bg-purple text-right text-white">{{ formatNumber(invoice_stats.subtot - invoice_stats.partially_paid, 0) }} kr</td>
                                </tr>
                                <!--                            <tr>-->
                                <!--                                <th>Delbetala</th>-->
                                <!--                                <td class="bg-purple text-right">{{ formatNumber(invoice_stats.subtot, 0) }} kr</td>-->
                                <!--                            </tr>-->
                                <!--                            <tr>-->
                                <!--                                <th>Inbetalt</th>-->
                                <!--                                <td class="bg-purple text-right">{{ formatNumber(0 - invoice_stats.partially_paid, 0) }} kr</td>-->
                                <!--                            </tr>-->
                                <tr>
                                    <th>Total skuld</th>
                                    <td class="bg-light text-right">
                                        {{ formatNumber(((invoice_stats.wait + invoice_stats.late + invoice_stats.subtot) - invoice_stats.partially_paid), 0) }} kr
                                    </td>
                                </tr>
                                <tr>
                                    <th>Ej återbetalt</th>
                                    <td class="bg-warning text-white text-right">
                                        {{ formatNumber(invoice_stats.not_refunded, 0) }} kr
                                    </td>
                                </tr>
                                <tr>
                                    <th>Summa</th>
                                    <td class="bg-light text-right">
                                        {{ formatNumber(((invoice_stats.wait + invoice_stats.late + invoice_stats.subtot) - invoice_stats.partially_paid) + invoice_stats.not_refunded, 0) }} kr
                                    </td>
                                </tr>
                                <tr v-if="invoice_stats.newport_debt > 0 || invoice_stats.fully_paid > 0">
                                    <th></th>
                                    <th></th>
                                </tr>
                                <tr v-if="invoice_stats.fully_paid > 0">
                                    <th>Fullbetalda</th>
                                    <td class="bg-success text-right">{{ formatNumber(invoice_stats.fully_paid, 0) }} kr</td>
                                </tr>
                            </tbody>
                        </table>
                    </div>
                </div>
            </div>
            <div v-else>
                <div class="alert alert-warning alert-styled-left">
                    <div class="font-weight-semibold">Ingen kundgrupp vald</div>
                    <div>Denna kund har ingen aktiv kundgrupp för försäljning, välj kundgrupp högst upp i formuläret för att skapa och visa ordrar.</div>
                </div>
            </div>

            <hr>
            <h1>Bisnode företagsinformation</h1>
            <bisnode-viewer v-if="customer.CustomerID > 0 && customer.OrgNo" :registration-number="customer.OrgNo.replace(/\D/g, '')"></bisnode-viewer>

            <b-modal
                id="modal_edit_contact"
                key="modal_edit_contact"
                title="Redigera kontakt"
                @ok="saveContact"
            >
                <ValidationObserver ref="contactform" v-if="contact">
                    <form @submit="saveContact">
                        <div class="row">
                            <div class="col-lg-6">
                                <input-with-validation
                                    vid="FullName"
                                    label="Namn"
                                    v-model="contact.FullName"
                                    rules="required"
                                ></input-with-validation>
                            </div>
                            <div class="col-lg-6">
                                <input-with-validation
                                    vid="Email"
                                    label="E-postadress"
                                    v-model="contact.Email"
                                ></input-with-validation>
                            </div>
                        </div>
                        <div class="row">
                            <div class="col-lg-6">
                                <input-with-validation
                                    vid="PhoneLandline"
                                    label="Telefon"
                                    v-model="contact.PhoneLandline"
                                ></input-with-validation>
                            </div>
                            <div class="col-lg-6">
                                <input-with-validation
                                    vid="PhoneMobile"
                                    label="Mobiltelefon"
                                    v-model="contact.PhoneMobile"
                                ></input-with-validation>
                            </div>
                        </div>
                        <div class="custom-control custom-checkbox custom-control-inline mb-3">
                            <input type="checkbox" class="custom-control-input" name="isMain" id="chk-isMain" :true-value="1" :false-value="0" v-model="contact.isMain">
                            <label class="custom-control-label" for="chk-isMain">Huvudkontakt / Reklamkontakt</label>
                        </div>
                        <select-with-validation
                            label="Standard postadress"
                            :options="addresses.filter((addr) => addr.isTypePostal)"
                            :reduce="(opt) => opt.DelivAdrID"
                            v-model="contact.PostalAdrID"
                            :get-option-label="joinAddressFields"
                        ></select-with-validation>
                        <select-with-validation
                            label="Standard leveransadress"
                            :options="addresses.filter((addr) => addr.isTypeDelivery)"
                            :reduce="(opt) => opt.DelivAdrID"
                            v-model="contact.DefaultDelivAdrID"
                            :get-option-label="joinAddressFields"
                        ></select-with-validation>
                    </form>
                </ValidationObserver>
                <template #modal-footer="{ ok, cancel }">
                    <limitless-button
                        ref="btndeletecontact"
                        type="button"
                        btn-class="btn-danger"
                        icon="icon-trash"
                        class="mr-auto"
                        @click="deleteContact"
                        :busy="busy_deleting_contact"
                        :disabled="busy_saving_contact"
                    >
                        RADERA
                    </limitless-button>
                    <button
                        type="button"
                        class="btn btn-light"
                        @click="cancel()"
                    >
                        Avbryt
                    </button>
                    <limitless-button
                        ref="btnsavecontact"
                        type="button"
                        @click="ok()"
                        :busy="busy_saving_contact"
                        icon="icon-floppy-disk"
                        :disabled="busy_deleting_contact"
                    >
                        SPARA
                    </limitless-button>
                </template>
            </b-modal>

            <b-modal
                id="modal_edit_address"
                key="modal_edit_address"
                title="Redigera adress"
                @ok="saveAddress"
            >
                <ValidationObserver ref="addressform" v-if="address">
                    <form @submit="saveAddress">
                        <div class="row">
                            <div class="col-lg-6">
                                <input-with-validation
                                    vid="DeliveryCompany"
                                    label="Företag"
                                    v-model="address.DeliveryCompany"
                                    rules="required"
                                    compact
                                ></input-with-validation>
                                <label>Adress</label>
                                <input-with-validation
                                    vid="DeliveryAddress1"
                                    label="Adressrad 1"
                                    v-model="address.DeliveryAddress1"
                                    hide-label
                                    compact
                                    class="mb-1"
                                ></input-with-validation>
                                <input-with-validation
                                    vid="DeliveryAddress2"
                                    label="Adressrad 2"
                                    v-model="address.DeliveryAddress2"
                                    hide-label
                                    compact
                                ></input-with-validation>
                                <div class="row">
                                    <div class="col-4">
                                        <input-with-validation
                                            vid="DeliveryZip"
                                            label="Postnummer"
                                            v-model="address.DeliveryZip"
                                            compact
                                        ></input-with-validation>
                                    </div>
                                    <div class="col-8">
                                        <input-with-validation
                                            vid="DeliveryCity"
                                            label="Postort"
                                            v-model="address.DeliveryCity"
                                            compact
                                        ></input-with-validation>
                                    </div>
                                </div>
                                <select-with-validation
                                    component="country-filter"
                                    vid="DeliveryCountryCode"
                                    label="Land"
                                    v-model="address.DeliveryCountryCode"
                                    :reduce="c => c.id"
                                    placeholder="Land"
                                ></select-with-validation>

                                <input-with-validation
                                    vid="DeliveryContactName"
                                    label="Kontakt"
                                    v-model="address.DeliveryContactName"
                                    compact
                                ></input-with-validation>
                                <div class="row">
                                    <div class="col-lg-6">
                                        <input-with-validation
                                            vid="DeliveryContactEmail"
                                            label="E-postadress"
                                            v-model="address.DeliveryContactEmail"
                                            compact
                                        ></input-with-validation>
                                    </div>
                                    <div class="col-lg-6">
                                        <input-with-validation
                                            vid="DeliveryContactPhone"
                                            label="Telefon"
                                            v-model="address.DeliveryContactPhone"
                                            compact
                                        ></input-with-validation>
                                    </div>
                                </div>
                            </div>
                            <div class="col-lg-6">
                                <div class="custom-control custom-checkbox custom-control-inline mb-2">
                                    <input type="checkbox" class="custom-control-input" name="isMain" id="chk-isMain" :true-value="1" :false-value="0" v-model="address.isMain">
                                    <label class="custom-control-label" for="chk-isMain"><i class="icon-star-full2 mr-1"></i>Huvudadress</label>
                                </div>
                                <div class="custom-control custom-checkbox custom-control-inline mb-2">
                                    <input type="checkbox" class="custom-control-input" name="isTypeDelivery" id="chk-isTypeDelivery" :true-value="1" :false-value="0" v-model="address.isTypeDelivery">
                                    <label class="custom-control-label" for="chk-isTypeDelivery"><i class="icon-truck mr-1"></i>Leveransadress (Åkerier/Bud)</label>
                                </div>
                                <div class="custom-control custom-checkbox custom-control-inline mb-2">
                                    <input type="checkbox" class="custom-control-input" name="isTypePostal" id="chk-isTypePostal" :true-value="1" :false-value="0" v-model="address.isTypePostal">
                                    <label class="custom-control-label" for="chk-isTypePostal"><i class="icon-envelop3 mr-1"></i>Postadress / Reklamadress</label>
                                </div>
                                <div class="custom-control custom-checkbox custom-control-inline mb-2">
                                    <input type="checkbox" class="custom-control-input" name="isTypeInvoicing" id="chk-isTypeInvoicing" :true-value="1" :false-value="0" v-model="address.isTypeInvoicing">
                                    <label class="custom-control-label" for="chk-isTypeInvoicing"><i class="icon-coins mr-1"></i>Fakturaadress</label>
                                </div>
                                <div v-if="address.isTypeInvoicing" class="custom-control custom-checkbox custom-control-inline mb-2">
                                    <input type="checkbox" class="custom-control-input" name="isDefaultInvoiceAdr" id="chk-isDefaultInvoiceAdr" :true-value="1" :false-value="0" v-model="address.isDefaultInvoiceAdr">
                                    <label class="custom-control-label" for="chk-isDefaultInvoiceAdr"><i class="icon-coins mr-1"></i>Standardval av fakturaadress</label>
                                </div>
                            </div>
                        </div>
                    </form>
                </ValidationObserver>
                <template #modal-footer="{ ok, cancel }">
                    <limitless-button
                        ref="btndeleteaddress"
                        type="button"
                        btn-class="btn-danger"
                        icon="icon-trash"
                        class="mr-auto"
                        @click="deleteAddress"
                        :busy="busy_deleting_address"
                        :disabled="busy_saving_address"
                    >
                        RADERA
                    </limitless-button>
                    <button
                        type="button"
                        class="btn btn-light"
                        @click="cancel()"
                    >
                        Avbryt
                    </button>
                    <limitless-button
                        ref="btnsaveaddress"
                        type="button"
                        @click="ok()"
                        :busy="busy_saving_address"
                        icon="icon-floppy-disk"
                        :disabled="busy_deleting_address"
                    >
                        SPARA
                    </limitless-button>
                </template>
            </b-modal>

            <b-modal
                id="modal_edit_price_lists"
                key="modal_edit_price_lists"
                title="Redigera specialpriser"
                size="xl"
                @ok="savePriceLists"
            >
                <ValidationObserver ref="pricelistform">
                    <form @submit.prevent="savePriceLists">
                        <table class="table table-xs table-striped border-bottom">
                            <thead>
                                <tr>
                                    <th style="width: 35%;">Kortserie</th>
                                    <th style="width: 18%;">Från</th>
                                    <th style="width: 18%;">Till</th>
                                    <th style="width: 18%;">Pris</th>
                                    <th style="width: 60px;"></th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr v-for="(pl, pl_idx) in all_price_lists" :key="'price-list-' + pl_idx">
                                    <td>
                                        <input
                                            v-if="pl.RowID > 0"
                                            type="text"
                                            class="form-control"
                                            :value="pl.CardSeriesID + (pl.SeriesName ? ' ' + pl.SeriesName : '')"
                                            disabled
                                        >
                                        <select-with-validation
                                            v-else
                                            :vid="'price_lists.' + pl_idx + '.CardSeriesID'"
                                            label="Kortserie"
                                            component="card-serie-filter"
                                            v-model="pl.CardSeriesID"
                                            :reduce="(opt) => opt.id"
                                            rules="required"
                                            hide-label
                                            compact
                                            no-bottom-margin
                                        ></select-with-validation>
                                    </td>
                                    <td>
                                        <ValidationProvider :vid="'price_lists.' + pl_idx + '.ValidFrom'" name="Giltig från" rules="" v-slot="{ errors }">
                                            <v-date-picker v-model="pl.ValidFrom" mode="date" :model-config="{ type: 'string', mask: 'YYYY-MM-DD' }" :masks="{ input: 'YYYY-MM-DD' }" show-iso-weeknumbers>
                                                <template v-slot="{ inputValue, togglePopover }">
                                                    <div class="input-group mb-0">
                                                        <input class="form-control" :class="{'border-danger':errors[0]}" :value="inputValue" @focus="togglePopover()">
                                                        <span class="input-group-append">
                                                            <button class="btn btn-light" type="button" @click="pl.ValidFrom = ''"><i class="icon-cross3"></i></button>
                                                        </span>
                                                    </div>
                                                </template>
                                            </v-date-picker>
                                            <span v-show="errors[0]" class="validation-invalid-label">{{ errors[0] }}</span>
                                        </ValidationProvider>
                                    </td>
                                    <td>
                                        <ValidationProvider :vid="'price_lists.' + pl_idx + '.ValidTo'" name="Giltig till" rules="" v-slot="{ errors }">
                                            <v-date-picker v-model="pl.ValidTo" mode="date" :model-config="{ type: 'string', mask: 'YYYY-MM-DD' }" :masks="{ input: 'YYYY-MM-DD' }" show-iso-weeknumbers>
                                                <template v-slot="{ inputValue, togglePopover }">
                                                    <div class="input-group mb-0">
                                                        <input class="form-control" :class="{'border-danger':errors[0]}" :value="inputValue" @focus="togglePopover()">
                                                        <span class="input-group-append">
                                                            <button class="btn btn-light" type="button" @click="pl.ValidTo = ''"><i class="icon-cross3"></i></button>
                                                        </span>
                                                    </div>
                                                </template>
                                            </v-date-picker>
                                            <span v-show="errors[0]" class="validation-invalid-label">{{ errors[0] }}</span>
                                        </ValidationProvider>
                                    </td>
                                    <td>
                                        <ValidationProvider :vid="'price_lists.' + pl_idx + '.Price_SEK'" name="Pris" rules="required" v-slot="{ errors }">
                                            <input type="number" step="0.01" class="form-control text-right" v-model="pl.Price_SEK" :class="{'border-danger':errors[0]}">
                                            <span v-show="errors[0]" class="validation-invalid-label">{{ errors[0] }}</span>
                                        </ValidationProvider>
                                    </td>
                                    <td class="text-right">
                                        <button type="button" class="btn btn-danger btn-icon btn-sm" @click="all_price_lists.splice(pl_idx, 1)">
                                            <i class="icon-trash"></i>
                                        </button>
                                    </td>
                                </tr>
                                <tr v-if="all_price_lists.length === 0">
                                    <td colspan="5"><i>Inga specialpriser</i></td>
                                </tr>
                            </tbody>
                        </table>
                        <button type="button" class="btn btn-light btn-sm" @click="addPriceListRow">
                            <i class="icon-plus3 mr-2"></i>Lägg till rad
                        </button>
                    </form>
                </ValidationObserver>
                <template #modal-footer="{ ok, cancel }">
                    <button
                        type="button"
                        class="btn btn-light"
                        @click="cancel()"
                    >
                        Avbryt
                    </button>
                    <limitless-button
                        ref="btnsavepricelists"
                        type="button"
                        @click="ok()"
                        :busy="busy_saving_price_lists"
                        icon="icon-floppy-disk"
                    >
                        SPARA
                    </limitless-button>
                </template>
            </b-modal>

            <activity-notification v-if="customer && customer.CustomerID > 0" :channel="'customer-' + customer.CustomerID"></activity-notification>
        </div>
        <div v-else class="content">
            <div class="alert alert-danger">Kunden hittades inte.</div>
        </div>
    </div>
</template>

<script>
import LimitlessPageHeader from '@components/Layout/partials/LimitlessPageHeader';
import LimitlessPageHeaderButton from '@components/Layout/partials/LimitlessPageHeaderButton';
import apiClient from '@services/ApiClient';
import getError from '@services/ErrorHelper';
import TextareaWithValidation from '@components/Form/TextareaWithValidation.vue';
import InputWithValidation from '@components/Form/InputWithValidation.vue';
import SelectWithValidation from '@components/Form/SelectWithValidation.vue';
import LimitlessButton from '@components/Limitless/LimitlessButton.vue';
import {
    formatCurrency,
    formatNumber,
    round,
} from '@services/Helpers';
import OrderList from '@app/pages/cardorder/partials/OrderList.vue';
import BackendRepository from '@services/repositories/BackendRepository';
import RednaxDatatable from '@components/Datatable/RednaxDatatableComponent.vue';
import ActivityNotification from '@components/User/ActivityNotification.vue';
import BisnodeViewer from '@components/CreditCheck/BisnodeViewer.vue';
import OpenStreetMapLeaflet from '@components/Map/OpenStreetMapLeaflet.vue';
import FileListUploader from '@components/Form/FileListUploader.vue';

export default {
    name: 'CustomerEdit',
    components: {
        FileListUploader,
        OpenStreetMapLeaflet,
        BisnodeViewer,
        ActivityNotification,
        RednaxDatatable,
        OrderList,
        LimitlessButton,
        SelectWithValidation,
        InputWithValidation,
        TextareaWithValidation,
        LimitlessPageHeader,
        LimitlessPageHeaderButton,
    },
    props: {
        id: {
            type: [Number, String],
            default: 0,
        },
    },
    data: () => ({
        not_found: false,
        initialized: false,
        busy_loading: true,
        busy_saving: false,
        busy_loading_addresses: false,
        busy_loading_contacts: false,
        busy_loading_price_lists: false,
        busy_loading_invoice_stats: false,
        busy_saving_contact: false,
        busy_deleting_contact: false,
        busy_saving_address: false,
        busy_deleting_address: false,
        busy_saving_price_lists: false,
        show_all_discounts: false,
        customer: null,
        contacts: [],
        addresses: [],
        price_lists: [],
        all_price_lists: [],
        contact: null,
        address: null,
        invoice_stats: null,
        languages: [
            {
                id: 'se_sv',
                label: 'Svenska',
            },
            {
                id: 'se_en',
                label: 'Engelska',
            },
            {
                id: 'fi_fi',
                label: 'Finska',
            },
            {
                id: 'fr_fr',
                label: 'Franska',
            },
        ],
        card_series_types: [],
        invoice_data: null,
        invoice_filter: {
            search: '',
            customer_id: null,
        },
    }),
    mounted() {
        this.init();
    },
    watch: {
        id() {
            this.init();
        },
    },
    methods: {
        round,
        formatNumber,
        formatCurrency,
        init() {
            this.not_found = false;
            this.initialized = false;
            this.busy_loading = true;
            this.busy_saving = false;
            this.busy_loading_invoice_stats = false;
            this.customer = null;
            this.contacts = [];
            this.addresses = [];
            this.price_lists = [];
            this.all_price_lists = [];
            this.contact = null;
            this.getCardSeriesTypes();
            this.getCustomer();
            if (parseInt(this.id, 10) > 0) {
                this.getCustomerContacts();
                this.getCustomerAddresses();
                this.getCustomerPriceLists();
            }
        },
        getCardSeriesTypes() {
            BackendRepository.getCardSeriesTypes().then((res) => {
                this.card_series_types = res;
            });
        },
        getCustomer() {
            this.busy_loading = true;
            apiClient.get('/vue/customers/' + this.id)
                .then((response) => {
                    this.customer = response.data;
                    this.invoice_filter.customer_id = response.data.CustomerID;
                })
                .finally(() => {
                    this.initialized = true;
                    this.busy_loading = false;
                });
        },
        getCustomerContacts() {
            this.busy_loading_contacts = true;
            apiClient.get('/vue/customers/' + this.id + '/contacts')
                .then((response) => {
                    this.contacts = response.data;
                })
                .finally(() => {
                    this.busy_loading_contacts = false;
                });
        },
        getCustomerAddresses() {
            this.busy_loading_addresses = true;
            apiClient.get('/vue/customers/' + this.id + '/addresses')
                .then((response) => {
                    this.addresses = response.data;
                })
                .finally(() => {
                    this.busy_loading_addresses = false;
                });
        },
        getCustomerPriceLists() {
            this.busy_loading_price_lists = true;
            apiClient.get('/vue/customers/' + this.id + '/price_lists')
                .then((response) => {
                    this.price_lists = response.data;
                })
                .finally(() => {
                    this.busy_loading_price_lists = false;
                });
        },
        showPriceListModal() {
            this.busy_loading_price_lists = true;
            apiClient.get('/vue/customers/' + this.id + '/price_lists?all=1')
                .then((response) => {
                    this.all_price_lists = response.data.map((row) => ({ ...row }));
                    this.$bvModal.show('modal_edit_price_lists');
                })
                .finally(() => {
                    this.busy_loading_price_lists = false;
                });
        },
        addPriceListRow() {
            this.all_price_lists.push({
                RowID: null,
                CustomerID: this.customer.CustomerID,
                CardSeriesID: null,
                Price_SEK: '',
                ValidFrom: '',
                ValidTo: '',
            });
        },
        async savePriceLists(event) {
            event.preventDefault();
            const isValid = await this.$refs.pricelistform.validate();
            if (isValid) {
                this.busy_saving_price_lists = true;
                apiClient.post('/vue/customers/' + this.customer.CustomerID + '/price_lists', {
                    price_lists: this.all_price_lists,
                }).then(() => {
                    this.$refs.btnsavepricelists.triggerSaved();
                    this.$bvModal.hide('modal_edit_price_lists');
                    this.getCustomerPriceLists();
                }).catch((error) => {
                    const parsederror = getError(error);
                    if (typeof parsederror === 'object') {
                        this.$refs.pricelistform.setErrors(parsederror);
                    }
                    this.$refs.btnsavepricelists.triggerFailed();
                }).finally(() => {
                    this.busy_saving_price_lists = false;
                });
            } else {
                this.$refs.btnsavepricelists.triggerFailed();
            }
        },
        getInvoiceStats(data) {
            if (data.stats) {
                this.invoice_stats = data.stats;
            }
        },
        async saveCustomer() {
            const isValid = await this.$refs.customerform.validate();
            if (isValid) {
                this.busy_saving = true;
                await apiClient.post('/vue/customers/' + this.customer.CustomerID, this.customer)
                    .then((response) => {
                        if (parseInt(this.id, 10) !== parseInt(response.data.CustomerID, 10)) {
                            this.$router.push({ name: 'customers.edit', params: { id: response.data.CustomerID } });
                        }
                        this.customer = response.data;
                        this.$refs.btnsavecustomer.triggerSaved();
                    })
                    .catch((error) => {
                        const parsederror = getError(error);
                        if (typeof parsederror === 'object') {
                            this.$refs.customerform.setErrors(parsederror);
                        }
                        this.$refs.btnsavecustomer.triggerFailed();
                    })
                    .finally(() => {
                        this.busy_saving = false;
                    });
            } else {
                this.$refs.btnsavecustomer.triggerFailed();
            }
        },
        joinAddressFields(address) {
            return [address.DeliveryCompany, address.DeliveryAddress1, address.DeliveryAddress2, address.DeliveryZip, address.DeliveryCity, address.DeliveryCountryCode]
                .filter((str) => str !== null && str !== '')
                .join(', ');
        },
        joinContactFields(contact) {
            return [
                contact.FullName,
                (contact.Email !== null && contact.Email !== '') ? `<a href="mailto:${contact.Email}">${contact.Email}</a>` : '',
                contact.PhoneLandline,
                contact.PhoneMobile,
            ].filter((str) => str !== null && str !== '').join(', ');
        },
        editContact(contact = null) {
            if (contact) {
                this.contact = { ...contact };
            } else {
                this.contact = {
                    ContactID: 0,
                    CustomerID: this.customer.CustomerID,
                    FullName: '',
                    Email: '',
                    PhoneLandline: '',
                    PhoneMobile: '',
                    isMain: 0,
                    PostalAdrID: null,
                    DefaultDelivAdrID: null,
                    StatusID: 0,
                };
            }
            this.$bvModal.show('modal_edit_contact');
        },
        async saveContact(event) {
            event.preventDefault();
            const isValid = await this.$refs.contactform.validate();
            if (isValid) {
                this.busy_saving_contact = true;
                apiClient.post('/vue/customercontacts/' + this.contact.ContactID, this.contact).then(() => {
                    this.$refs.btnsavecontact.triggerSaved();
                    this.$bvModal.hide('modal_edit_contact');
                    this.getCustomerContacts();
                }).catch((error) => {
                    const parsederror = getError(error);
                    if (typeof parsederror === 'object') {
                        this.$refs.contactform.setErrors(parsederror);
                    }
                    this.$refs.btnsavecontact.triggerFailed();
                }).finally(() => {
                    this.busy_saving_contact = false;
                });
            } else {
                this.$refs.btnsavecontact.triggerFailed();
            }
        },
        async deleteContact() {
            this.$swal({
                icon: 'warning',
                title: 'Vill du verkligen radera?',
                showCancelButton: true,
                confirmButtonText: 'Ja, radera',
                cancelButtonText: 'Avbryt',
            }).then(async (result) => {
                if (result.value) {
                    this.busy_deleting_contact = true;
                    await apiClient.delete('/vue/customercontacts/' + this.contact.ContactID)
                        .then(() => {
                            this.$refs.btndeletecontact.triggerSaved();
                            this.getCustomerContacts();
                            $('#modal_edit_contact').modal('hide');
                        })
                        .catch(() => {
                            this.$refs.btndeletecontact.triggerFailed();
                        })
                        .finally(() => {
                            this.busy_deleting_contact = false;
                        });
                }
            });
        },
        editAddress(address = null) {
            if (address) {
                this.address = { ...address };
            } else {
                this.address = {
                    DelivAdrID: 0,
                    CustomerID: this.customer.CustomerID,
                    isTypeDelivery: 0,
                    isTypePostal: 0,
                    isTypeInvoicing: 0,
                    DeliveryCompany: null,
                    DeliveryAddress1: null,
                    DeliveryAddress2: null,
                    DeliveryZip: null,
                    DeliveryCity: null,
                    DeliveryCountryCode: 'SE',
                    DeliveryContactName: null,
                    DeliveryContactEmail: null,
                    DeliveryContactPhone: null,
                    isMain: 0,
                };
            }
            this.$bvModal.show('modal_edit_address');
        },
        async saveAddress(event) {
            event.preventDefault();
            const isValid = await this.$refs.addressform.validate();
            if (isValid) {
                this.busy_saving_address = true;
                apiClient.post('/vue/customeraddresses/' + this.address.DelivAdrID, this.address).then(() => {
                    this.$refs.btnsaveaddress.triggerSaved();
                    this.$bvModal.hide('modal_edit_address');
                    this.getCustomerAddresses();
                }).catch((error) => {
                    const parsederror = getError(error);
                    if (typeof parsederror === 'object') {
                        this.$refs.addressform.setErrors(parsederror);
                    }
                    this.$refs.btnsaveaddress.triggerFailed();
                }).finally(() => {
                    this.busy_saving_address = false;
                });
            } else {
                this.$refs.btnsaveaddress.triggerFailed();
            }
        },
        async deleteAddress() {
            this.$swal({
                icon: 'warning',
                title: 'Vill du verkligen radera?',
                showCancelButton: true,
                confirmButtonText: 'Ja, radera',
                cancelButtonText: 'Avbryt',
            }).then(async (result) => {
                if (result.value) {
                    this.busy_deleting_address = true;
                    await apiClient.delete('/vue/customeraddresses/' + this.address.DelivAdrID)
                        .then(() => {
                            this.$refs.btndeleteaddress.triggerSaved();
                            this.getCustomerAddresses();
                            $('#modal_edit_address').modal('hide');
                        })
                        .catch(() => {
                            this.$refs.btndeleteaddress.triggerFailed();
                        })
                        .finally(() => {
                            this.busy_deleting_address = false;
                        });
                }
            });
        },
        async invoiceRowClick(data, event) {
            if (event.metaKey === true || event.ctrlKey === true) {
                const route = this.$router.resolve({ name: 'invoice.edit', params: { id: data.InvoiceID } });
                window.open(route.href).focus();
            } else {
                await this.$router.push({ name: 'invoice.edit', params: { id: data.InvoiceID } });
            }
        },
    },
    computed: {
        customer_name() {
            return (this.customer && this.customer.CustomerID > 0 ? this.customer.CompanyName : 'Ny kund');
        },
        customer_id() {
            return (this.customer && this.customer.CustomerID > 0 ? this.customer.CustomerID : '');
        },
        old_system_url() {
            return window.config.app.old_system_url;
        },
        filtered_card_series_types_discounts() {
            if (!this.show_all_discounts) {
                return this.card_series_types.filter((cst) => !!(this.customer.baseDiscount[cst.label]));
            }
            return this.card_series_types;
        },
        filtered_map_addresses() {
            if (this.addresses.length > 0) {
                return this.addresses.filter((addr) => (addr.isTypeDelivery && addr.deliv_time && addr.deliv_time.geo_latitude));
            }
            return [];
        },
        invoice_columns() {
            if (this.customer) {
                return [
                    {
                        header: 'OCR',
                        data: 'InvoiceID',
                        sortable: true,
                    },
                    {
                        header: 'Order',
                        data: 'OrderID',
                        sortable: true,
                    },
                    {
                        header: 'Fakturadatum',
                        data: 'InvoiceDate',
                        sortable: true,
                    },
                    {
                        header: 'Förfallodatum',
                        data: 'ExpireDate',
                        sortable: true,
                    },
                    {
                        header: 'Nettobelopp',
                        data: 'InvoiceSum',
                        sortable: true,
                        align_right: true,
                    },
                    {
                        header: 'Fakturabelopp',
                        data: 'InvoiceSumFull',
                        sortable: true,
                        align_right: true,
                    },
                    {
                        header: 'Skuld',
                        data: 'debt',
                        sortable: true,
                        align_right: true,
                    },
                    {
                        header: 'Dagar kvar',
                        data: 'LateDays',
                        sortable: true,
                        align_right: true,
                    },
                    {
                        header: 'Status',
                        data: 'Status',
                        sortable: true,
                    },
                ];
            }
            return [];
        },
    },
};

</script>
